<h1 matDialogTitle>{{data?.dialogTitle}}</h1>

<mat-dialog-content>
  <button type="button" mat-raised-button (click)="fileInput.click()" style="margin-bottom: 16px">
    <mat-icon class="mat-18">upload</mat-icon>Upload File
  </button>
  <input hidden #fileInput type="file" (change)="onFileChange($event)" />
  <optsol-ngx-data-table *ngIf="tableConfig" [config]="tableConfig" [data]="tableData"></optsol-ngx-data-table>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button matDialogClose>Cancel</button>
  <button [disabled]="!dataValid" mat-raised-button color="primary" (click)="submit()">OK</button>
</mat-dialog-actions>